export default "__VITE_ASSET__BzjFkg8G__"